(function () {
    function setToken(input, token) {
        if (input) {
            input.value = token || '';
        }
    }

    function getTheme() {

        return {
            general: {
                primary: window.getComputedStyle(document.body).getPropertyValue('--brand-color-primary'),
            },
        };

    }

    function renderWidget(container) {
        var hiddenInputId = container.getAttribute('data-captchafox-target');
        var hiddenInput = hiddenInputId ? document.getElementById(hiddenInputId) : null;
        var sitekey = container.getAttribute('data-sitekey');
        var lang = container.getAttribute('data-lang');
        var widgetId;
        var options;

        if (!window.captchafox || !hiddenInput || !sitekey || container.getAttribute('data-captchafox-rendered') === 'true') {
            return;
        }

        setToken(hiddenInput, '');

        options = {
            onError: function () {
                setToken(hiddenInput, '');
            },
            onExpire: function () {
                setToken(hiddenInput, '');

                if (typeof widgetId !== 'undefined') {
                    window.captchafox.reset(widgetId);
                }
            },
            onFail: function () {
                setToken(hiddenInput, '');
            },
            onVerify: function (token) {
                setToken(hiddenInput, token);
            },
            sitekey: sitekey,
            theme: getTheme(),
        };

        if (lang) {
            options.lang = lang;
        }

        widgetId = window.captchafox.render(container, options);
        container.setAttribute('data-captchafox-rendered', 'true');
        container.setAttribute('data-captchafox-widget-id', String(widgetId));
    }

    window.initCaptchaFox = function initCaptchaFox() {
        var containers = document.querySelectorAll('[data-captchafox]');
        var index;

        for (index = 0; index < containers.length; index += 1) {
            renderWidget(containers[index]);
        }
    };

    if (document.readyState !== 'loading') {
        window.initCaptchaFox();
    } else {
        document.addEventListener('DOMContentLoaded', function () {
            window.initCaptchaFox();
        });
    }
}());
